<template>
    <div id="PrivacyPolicy">
        <div class="container">
            <div class="row">
              <div class="col-12">
                  <!-- <div v-if="policy" class="ql-editor"> -->
                    <div  v-html="policy"></div>
                  <!-- </div> -->
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.bubble.css';

export default {
  data(){
    return {
      policy: ""
    }
  },
  async created() {
    try{
        const { data: { results } }  = await this.$store.$oddjob.settings.getConfigTermsPolicyUrl("policy_html");
        if(results && results.length){
            this.policy = results[0].value;
        }
    }catch(err){
        console.log("API get config ")
    }
  }
}
</script>
<style lang="scss">
#PrivacyPolicy{
  line-height: 26px;
  font-size: 14px;
  padding: 0px;
}
</style>
<style lang="scss" scoped>

</style>